import { Environment } from './types';

export const firebaseApiKey = 'AIzaSyC9SifC8h3uIsTSX1PK_t9RUxhTZTEyipI';
export const rollbarToken = 'e2c1c5d4a4a84ad7961bd36fc1f3d890';

/* tslint:disable */
const backendUrl: string = 'https://api-test.ideta.io';
export const environment: Environment = {
  production: false,
  localLogin: false,
  product: 'autocomment',
  name: 'demo',
  backendUrl,
  useSupportBot: false,
  products: {
    connect: 'https://connect-test.ideta.io',
    default: 'https://app-test.ideta.io',
    webhooks: 'https://webhooks-test.ideta.io',
    livechat: 'https://livechat-test.ideta.io',
    inbox: 'https://inbox-test.ideta.io',
    autocomment: 'https://private-replies-test.ideta.io'
  },
  firebase: {
    authDomain: 'app-test.ideta.io',
    databaseURL: 'https://trhs-sandbox1.firebaseio.com',
    projectId: 'trhs-sandbox1',
    storageBucket: 'trhs-sandbox1.appspot.com',
    messagingSenderId: '1059659963313'
  },
  stripe: {
    paymentGPTUrl: 'https://buy.stripe.com/fZe5mt7EZgyS47ucNd',
    paymentUrlMonthly: 'https://buy.stripe.com/14k5mt4sN6Yi7jG7sM',
    paymentUrlGPTPlus: 'https://buy.stripe.com/fZe3elbVffuO6fC14F',
    paymentUrlOptionsDelay: 'https://buy.stripe.com/5kA6qx8J35Ue6fC3cM',
    managePlanUrl: 'https://billing.stripe.com/p/login/3cs15B4ew98P4RG3cc',
    paymentUrlTopup9: 'https://buy.stripe.com/cN28yFf7rciCcE05kZ',
    paymentUrlTopup29: 'https://buy.stripe.com/8wM9CJ6AVeqK33qbJk',
    paymentUrlTopup59: 'https://buy.stripe.com/14k8yF5wRfuOcE014I'
  },
  instagram: {
    appId: '727293309529965',
    redirect_uri: `${backendUrl}/aicm/connect/instagram`,
    url: 'https://graph.instagram.com',
    version: '20.0',
    auth_uri: 'https://www.instagram.com/oauth/authorize'
  },
  facebook: {
    appId: '1504775273759776',
    xfbml: true,
    version: 'v20.0',
    cookie: true,
    logging: true,
    url: 'https://graph.facebook.com'
  },
  rollbar: {
    active: true,
    buildVersion: 'eb35b86'
  },
  appSettings: {
    maxPaginatedUserListLength: 50,
    maxLastUserListLength: 100,
    typingVisualDelay: 1500,
    maxQuickReplyElements: 20,
    emptyTemplateImg: 'https://img.icons8.com/pastel-glyph/2x/empty-box.png',
    maxKeyNameLength: 100,
    maxPropertyNameLength: 100,
    delayBeforeCokcpitNodeResend: 5000,
    defaultCredits: 500
  }
};
/* tslint:enable */
